import React from "react";
import { Link } from "react-router-dom";

/**
 * What the export page shows once the file exists.
 *
 * Without a finished state the page fell straight back to the selection form
 * the moment an export completed. A user who had left and returned no longer
 * has a selection in this tab, so the form rendered its empty state and told
 * them to "select properties from the search page" - directly beside a toast
 * saying the export was ready.
 */
const ExportDone = ({ summary, url }) => (
  <section className="export_sec">
    <div className="contain-fluid">
      <div className="export_done">
        <h3>Export ready</h3>
        <p>{summary}</p>
        <p className="export_progress_line">
          The download starts automatically. Your file is also kept under Saved
          Exports.
        </p>
        <div className="btn_blk">
          {url && (
            <a className="site_btn" href={url} rel="noopener noreferrer">
              Download again
            </a>
          )}
          <Link
            className="site_btn blank"
            to="/account-settings"
            // The account page selects its tab from this key, so the link lands
            // on Saved Exports instead of whichever tab was last opened.
            onClick={() =>
              localStorage.setItem("accout-settings-active-tab", "Exports")
            }
          >
            Saved exports
          </Link>
          <Link className="site_btn blank" to="/search-property">
            Back to search
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default ExportDone;
